import React from 'react';
import { cn } from 'lib/utils';
import DashboardNavbar from 'components/navbar/dashboard-navbar';
import Sidebar from 'components/sidebar';
import { useLocation } from 'react-router-dom';

const PrivateLayout = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const isMarketplace = location.pathname.endsWith('/marketplace');

  return (
    <div className='flex flex-col'>
      <DashboardNavbar />
      <div className="flex min-h-screen relative">
      <Sidebar />
        <div
          className={cn(
            // min-w-0 lets this flex column shrink below its content's intrinsic
            // width so wide children (e.g. grid tables) scroll inside their own
            // overflow-x-auto wrapper instead of forcing the whole page wider.
            'flex-1 min-w-0',
            isMarketplace
              ? 'p-0 h-screen overflow-hidden relative'
              : 'p-8 max-md:p-0'
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default PrivateLayout;
